module.exports = __webpack_public_path__ + "media/images/cleaning/cover-desktop-0c6e8fd1725084314b107ad95c957d64.jpg";